export const jobTitles = [
  ['s','o','f','w','a','r','e',' ','e','n','g','i','n','e','e','r','.'],
  ['s','o','f','t','w','a','r','e',' ','d','e','v','e','l','o','p','e','r','.'],
  ['w','e','b',' ','d','e','v','e','l','o','p','e','r','.'],
  ['b','a','c','k','e','n','d',' ','e','n','g','i','n','e','e','r','.'],
  ['f','r','o','n','t','e','n','d',' ','e','n','g','i','n','e','e','r','.']
];